/**
 * A stable, readable value for the `faq_question` GA4 dimension: the question as a slug.
 * Shared by the banded service pages (managed IT, AI) so the same question gives the same value.
 */
export const faqSlug = (question: string): string =>
  question.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 100);

export default faqSlug;
